import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { createReportVersionVulnerabilityActionRoute, reportVersionVulnerabilityRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { CreateReportVulnerabilityActionForm } from "app/component/report-vulnerability-action/CreateReportVulnerabilityActionForm";

export const CreateReportVersionVulnerabilityActionScreen: FC = () => {
    const { reportId, versionId, vulnerabilityId } = useRouteParams(createReportVersionVulnerabilityActionRoute);
    const [created, setCreated] = useState(false);

    return created ? (
        <Navigate to={reportVersionVulnerabilityRoute.build({ reportId, versionId, vulnerabilityId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={createReportVersionVulnerabilityActionRoute} />
                <CreateReportVulnerabilityActionForm
                    vulnerabilityId={vulnerabilityId}
                    versionId={versionId}
                    onCreate={() => setCreated(true)}
                />
            </Container>
        </NavigationScreen>
    );
};
